module.exports = __webpack_public_path__ + "c2e8f203a6177d028f49a4beddde4491.png";